import { createGlobalStyle } from 'styled-components';



import KievitOT_Book  from './KievitOT-Book.otf'
import KievitOT_Bold  from './KievitOT-Bold.otf'
import KievitOT_Regular  from './KievitOT-Regular.otf'
import KievitOT_Black from './KievitOT-Black.otf'
 




export default createGlobalStyle`
    @font-face {
        font-family: Kievit OT;
        src:
 
        url(${KievitOT_Regular}) format('opentype'),
   
    
    }

    @font-face {
        font-family: Kievit OT;
        src:url(${KievitOT_Bold}) format('opentype');
        font-weight:bold;
  
    
    }

    @font-face {
        font-family: Kievit OT;
        src:url(${KievitOT_Book}) format('opentype');
        font-weight:medium;
  
    
    }


`;


